module.exports = __webpack_public_path__ + "img/mechanic.8776d4e4.jpeg";